export const errorHandler = (error, messageContainer, fallbackError = 'Something went wrong, please try again') => {
    console.log(error, messageContainer, "error handler");
    if (error && error?.code == 403) {
        messageContainer.error(error?.errorInfo?.message);
    } else {
        console.log('error bifurcation: ', error?.error?.split('~'));
        if (error?.error?.split('~')?.length) {
            const newErrorList = error?.error?.split('~');
            newErrorList.map(errorItem => messageContainer.error(errorItem || fallbackError));

        } else {

            messageContainer.error(error?.error || fallbackError);
        }
    }
}